<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="question" :title="Title"/>
    <div class="rule container qa">
      <h1 class="title lkrule"><span>{{ Title }}</span></h1>
      <section class="rule-cont question" v-for="(box ,a) in Question" :key="a">
        <div v-bind:id="'question-'+ a" class="anchor"></div>
        <div class="title">{{ box.title }}</div>
        <b-card v-for="(item, index) in box.card" :key="index" :class="item.qaClass">
          <b-button variant="question" v-b-toggle="'sort' + index+a" role="tab">
            <span class="icon"></span><span class="text">{{ item.title }}</span>
          </b-button>
          <b-collapse :id="'sort' + index + a" class="mt-2" role="tabpanel" accordion="my-accordion">
            <div class="collapseContent">
              <div class="card-text">
                <span v-html="item.text"></span>
                <span v-html="item.text1"></span>
                <div class="qaContent" v-html="item.content"></div>
              </div>
              <div v-if="item.blockShow" class="card-text qa_usdt_01">
                <div class="qa_title"> {{ item.subtitle01 }} </div>
                <span class="dn img1"></span>
                <span class="dn img2"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text11"></span>
                  <span v-html="item.text12"></span>
                  <span v-html="item.text13"></span>
                </div>

              </div>
              <div v-if="item.blockShow" class="card-text qa_usdt_02">
                <div class="qa_title"> {{ item.subtitle02 }} </div>
                <span class="dn img3"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text21"></span>
                  <span v-html="item.text22"></span>
                  <span v-html="item.text23"></span>
                </div>
                <span class="dn img4"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text24"></span>
                  <span v-html="item.text25"></span>
                </div>
              </div>
              <div v-if="item.blockShow" class="card-text qa_usdt_03">
                <div class="qa_title"> {{ item.subtitle03 }} </div>
                <span class="dn img5"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text31"></span>
                  <span v-html="item.text32"></span>
                </div>
              </div>
              <div v-if="item.blockShow" class="card-text qa_usdt_04">
                <div class="qa_title"> {{ item.subtitle04 }} </div>
                <span class="dn img6"></span>
                <span class="dn img7"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text41"></span>
                  <span v-html="item.text42"></span>
                </div>
                <span class="dn img8"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text43"></span>
                  <span v-html="item.text44"></span>
                  <span v-html="item.text45"></span>
                </div>
                <span class="dn img9"></span>
                <span class="qa_usdt_content" v-html="item.text46"></span>
              </div>
              <div v-if="item.blockShow" class="card-text qa_usdt_05">
                <div class="qa_title"> {{ item.subtitle05 }} </div>
                <span class="dn img10"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text51"></span>
                  <span v-html="item.text52"></span>
                  <span v-html="item.text53"></span>
                  <span v-html="item.text54"></span>
                  <span v-html="item.text55"></span>
                </div>
                <span class="dn img11"></span>
                <span class="qa_usdt_content" v-html="item.text56"></span>
              </div>
              <div v-if="item.blockShow" class="card-text qa_usdt_06">
                <div class="qa_title"> {{ item.subtitle06 }} </div>
                <span class="dn img12"></span>
                <span class="dn img13"></span>
                <span class="qa_usdt_content" v-html="item.text61"></span>
                <span class="dn img14"></span>
                <span class="qa_usdt_content" v-html="item.text62"></span>
                <span class="dn img15"></span>
                <span class="qa_usdt_content" v-html="item.text63"></span>
                <span class="dn img16"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text64"></span>
                  <span v-html="item.text65"></span>
                </div>
                <span class="dn img17"></span>
                <span class="dn img18"></span>
                <span class="qa_usdt_content" v-html="item.text66"></span>
              </div>
              <div v-if="item.blockShow" class="card-text qa_usdt_07">
                <div class="qa_title"> {{ item.subtitle07 }} </div>
                <span class="dn img19"></span>
                <span class="dn img20"></span>
                <span class="qa_usdt_content" v-html="item.text71"></span>
                <span class="dn img21"></span>
                <span class="dn img22"></span>
                <div class="qa_usdt_content">
                  <span v-html="item.text72"></span>
                  <span v-html="item.text73"></span>
                </div>
              </div>
              <b-button :href="item.url" target="_blank" :variant="item.none">{{ item.button }}</b-button>
            </div>
          </b-collapse>
        </b-card>
      </section>
    </div>
  </div>
</template>
<script>
  import { getJsonFile } from '@/utils/jsonFile';
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    components: { pageHead },
    computed: {
      Question() {
        return getJsonFile(process.env.DEF_webStyle, `question_${this.$i18n.locale}`);
      },
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        return this.$t("store.help_question") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
      }
    }
  };
</script>

